const ROOT_PATHS = new Set(["/", "/home"]);

const trimTrailingSlashes = (path) => {
  let end = path.length;
  while (end > 1 && path[end - 1] === "/") {
    end--;
  }
  return path.slice(0, end);
};

export const isRootPath = (pathname = "/") =>
  ROOT_PATHS.has(trimTrailingSlashes(pathname));

/**
 * Where "back" goes when there is no in-app history (deep link, notification,
 * fresh WebView). Only real pages are returned: most section roots
 * (/smartPath, /myaccount, /towingPayload…) redirect to a child, so stepping
 * up to them would bounce straight back.
 */
export const getParentPath = (pathname = "/") => {
  const path = trimTrailingSlashes(pathname);
  if (ROOT_PATHS.has(path)) {
    return null;
  }

  const [, first, second, third, fourth] = path.split("/");

  if (first === "product" && second && third && fourth) {
    return `/product/${second}/${third}`;
  }
  if (first === "articles") {
    return "/browse";
  }
  if (first === "glossary" && second) {
    return "/glossary";
  }
  return "/home";
};
